import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LabLockEntry } from '../models/lab-lock-entry.model';
import { LabLockSchema } from '../schemas/lab-lock.schema';
import { GraphqlService } from './graphql.service';

@Injectable({
	providedIn: 'root'
})
export class LabLockService extends GraphqlService {
	/**
	 * Accept LabLock
	 */
	acceptLabLock(activationCode: string): Observable<LabLockEntry> {
		return this.mutation(
			LabLockSchema.acceptLabLock,
			{
				activationCode
			},
			{ showSuccessMessage: false }
		).pipe(map((response: any) => LabLockEntry.map(response.acceptLabLock)));
	}

	/**
	 * Add LabLock entry
	 */
	addLabLockEntry(workstationId: string, inventoryNumber: string, dentistUserName: string): Observable<boolean> {
		return this.mutation(LabLockSchema.addLabLockEntry, {
			workstationId,
			inventoryNumber,
			dentistUserName
		}).pipe(map((response: any) => response.addLabLockEntry));
	}

	/**
	 * Deactivate LabLock
	 */
	deactivateLabLock(labLockEntryUid: string): Observable<boolean> {
		return this.mutation(LabLockSchema.deactivateLabLock, {
			labLockEntryUid
		}).pipe(map((response: any) => response.deactivateLabLock));
	}

	/**
	 * Auth options
	 */
	getAuthOptions() {
		return {
			headers: new HttpHeaders({
				Authorization: 'Bearer ' + this.sessionService.session.accessToken,
				'Session-Id': this.sessionService.session.uid
			})
		};
	}

	/**
	 * Send reminder mail
	 */
	sendReminderMail(labLockEntryUid: string): Observable<Object> {
		return new Observable<Object>((subscriber) => {
			this.sessionService.check().subscribe(() => {
				// Send email
				this.http.get(this.configService.config.emailService.labLockReminderUri + labLockEntryUid, this.getAuthOptions()).subscribe(
					(result) => {
						subscriber.next(result);
						subscriber.complete();
					},
					(error) => {
						subscriber.error(error);
					}
				);
			});
		});
	}

	/**
	 * Send created mail
	 */
	sendCreatedMail(labLockEntryUid: string): Observable<Object> {
		return new Observable<Object>((subscriber) => {
			// Send email
			this.sessionService.check().subscribe(() => {
				this.http.get(this.configService.config.emailService.labCreatedLabLockUri + labLockEntryUid, this.getAuthOptions()).subscribe(
					(result) => {
						subscriber.next(result);
						subscriber.complete();
					},
					(error) => {
						subscriber.error(error);
					}
				);
			});
		});
	}
}
